"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const team = [{
    role: "SENIOR TAX STRATEGIST",
    name: "Marcus Lovejoy",
    years: "17 YEARS / LOVEJOY",
    quote: "On compliance: accuracy is the foundation of long-term growth.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/tax_strategist_marcus.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/tax_strategist_marcus.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/tax_strategist_marcus.webp-wvc-sizes",
    alt: "Portrait of Marcus Lovejoy, Senior Tax Strategist"
  }, {
    role: "CORPORATE TAX LEAD",
    name: "Elena Sterling",
    years: "14 YEARS / LOVEJOY",
    quote: "On planning: proactive strategy turns tax burdens into opportunities.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/corporate_tax_elena.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/corporate_tax_elena.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/corporate_tax_elena.webp-wvc-sizes",
    alt: "Portrait of Elena Sterling, Corporate Tax Lead"
  }, {
    role: "COMPLIANCE DIRECTOR",
    name: "Toshiro Tanaka",
    years: "12 YEARS / LOVEJOY",
    quote: "On integrity: transparency builds the trust that sustains a business.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/compliance_director_toshiro.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/compliance_director_toshiro.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/compliance_director_toshiro.webp-wvc-sizes",
    alt: "Portrait of Toshiro Tanaka, Compliance Director"
  }, {
    role: "INDIVIDUAL ADVISOR",
    name: "Iris Vance",
    years: "11 YEARS / LOVEJOY",
    quote: "On clarity: simplifying complex codes brings peace of mind.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/individual_advisor_iris.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/individual_advisor_iris.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/individual_advisor_iris.png-wvc-sizes",
    alt: "Portrait of Iris Vance, Individual Advisor"
  }, {
    role: "FINANCIAL ANALYST",
    name: "Daniel Okafor",
    years: "13 YEARS / LOVEJOY",
    quote: "On precision: every deduction counts toward your financial stability.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/financial_analyst_daniel.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/financial_analyst_daniel.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/financial_analyst_daniel.webp-wvc-sizes",
    alt: "Portrait of Daniel Okafor, Financial Analyst"
  }, {
    role: "CLIENT RELATIONS",
    name: "Samantha Thorne",
    years: "10 YEARS / LOVEJOY",
    quote: "On service: personalized attention is the hallmark of our firm.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_relations_samantha.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_relations_samantha.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/client_relations_samantha.png-wvc-sizes",
    alt: "Portrait of Samantha Thorne, Client Relations"
  }];
  return <section data-section-id="4673" id="meet-the-professionals" className="bg-background text-foreground py-24 md:py-36 lg:py-44 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1440px] mx-auto">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-8">
            <div className="font-mono text-xs tracking-[0.25em] uppercase text-foreground mb-8">
              — The Experts at Lovejoy
            </div>
            <h2 className="font-default font-bold text-foreground leading-[0.95] tracking-tight text-5xl md:text-7xl lg:text-[96px]">
              <span className="block">The minds</span>
              <span className="block font-serif italic font-normal">guiding your</span>
              <span className="block">future.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-end">
            <p className="font-serif text-foreground/70 text-lg md:text-xl leading-relaxed">
              A dedicated team of certified tax professionals. Each advisor has averaged over a decade of experience with Lovejoy Company.
            </p>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-28 lg:mt-32 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {team.map((member, i) => <TeamCard key={i} member={member} index={i} />)}
        </div>
      </div>
    </section>;
}
function TeamCard({
  member,
  index
}: {
  member: {
    role: string;
    name: string;
    years: string;
    quote: string;
    image: string;
    srcset: string;
    sizes: string;
    alt: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div data-index={index} ref={ref} style={{
    transitionDelay: `${index % 3 * 100}ms`
  }} className={`group relative backdrop-blur-sm border bg-card border-border shadow-md transition-all duration-700 ease-out hover:-translate-y-1.5 hover:shadow-lg ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      {}
      <div className="relative w-full overflow-hidden aspect-[4/5]">
        <img src={member.image} data-wvc-srcset={member.srcset} data-wvc-sizes={member.sizes} alt={member.alt} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale contrast-125 transition-all duration-[600ms] ease-out group-hover:grayscale-0 group-hover:contrast-100" />
      </div>

      {}
      <div className="p-8 pt-6">
        <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-muted-foreground mb-3">
          {member.role}
        </div>
        <h3 className="font-default text-foreground text-3xl leading-tight mb-3">
          {member.name}
        </h3>
        <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-muted-foreground mb-5">
          {member.years}
        </div>
        <p className="font-serif italic text-sm leading-relaxed text-foreground/80">
          {member.quote}
        </p>
      </div>

      {}
      <span className="pointer-events-none absolute left-0 bottom-0 h-px w-0 bg-accent transition-all duration-500 ease-out group-hover:w-full" />
    </div>;
}